module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('h1', {
    staticClass: "float-left display-3 mr-4"
  }, [_vm._v("404")]), _vm._v(" "), _c('h4', {
    staticClass: "pt-3"
  }, [_vm._v("Ой! Вы потерялись =(")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Данная страницы нет, но есть "), _c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("главная")]), _vm._v(".")], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ce0eebe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/Page404.vue
// module id = 514
// module chunks = 0